<template>
  <div class="lottie-bg">
    <div id="lottie">
      <img
        src="@assets/images/live-logo.gif"
        rel="preload"
        style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import { auth, takeOauthBackUrl } from "@libs/wechat";
import { parseQuery } from "@utils";

export default {
  name: "Loading",
  mounted() {
    const query = parseQuery();
    const code = query.code;
    let back = "/";
    if (this.$route.params.url) {
      try {
        back = decodeURIComponent(decodeURIComponent(this.$route.params.url));
      } catch (e) {
        back = "/";
      }
    } else {
      back = takeOauthBackUrl(query.state);
    }
    if (!back || back.indexOf("/login") === 0 || back.indexOf("/auth/") !== -1) {
      back = "/";
    }
    if (!code) {
      location.replace(back);
      return;
    }
    auth(code)
      .then(() => {
        location.replace(back);
      })
      .catch(() => {
        location.replace("/");
      });
  }
};
</script>

<style scoped>
.lottie-bg {
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}

#lottie {
  width: 35%;
  display: block;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin: auto;
}
</style>
